import React from 'react';
import classnames from 'classnames';
import styles from './RequestResponseTab.module.scss';
import { useQuery } from 'react-query';
import { Spinner } from 'react-bootstrap';
import { DataVendor, ProposalEntity, SearchEntity } from 'v2/models';
import restFactory from 'v2/utils/restFactory';
import {
  buildSearchResponse,
  getSearchStatus,
} from 'v2/pages/SearchDetails/SearchResponse/SearchResponses';
import SearchResponseItem from 'v2/pages/SearchDetails/SearchResponse/SearchResponseItem';

interface RequestResponseTabProps {
  request: SearchEntity;
  dataVendor: DataVendor;
}

const RequestResponseTab = ({
  request,
  dataVendor,
}: RequestResponseTabProps) => {
  const { data: proposals, isLoading: isProposalLoading } = useQuery(
    [
      'Get specific proposal by request and data provider id',
      dataVendor.data_provider,
      request.id,
    ],
    async () => {
      const response = await restFactory.get<ProposalEntity[]>('/proposals', {
        b: true,
        request__id: request.id,
        data_provider__id: dataVendor.data_provider,
      });
      return response;
    },
    {
      cacheTime: 0,
      refetchOnWindowFocus: false,
    }
  );

  if (isProposalLoading) {
    return (
      <div className={classnames(styles.loading)} aria-label="loading-spinner">
        <Spinner animation="border" />
      </div>
    );
  }

  if (!proposals?.length) {
    return null;
  }

  return (
    <div>
      {proposals?.map((proposal) => {
        const proposalAdjusted = buildSearchResponse(
          getSearchStatus(proposal, true),
          proposal,
          request.active
        );
        return (
          <SearchResponseItem
            key={proposal.id}
            className={classnames(styles.root)}
            onAccepted={() => null}
            showActions={false}
            showDataProviderInfo={false}
            request={request}
            {...proposalAdjusted}
          />
        );
      })}
    </div>
  );
};

export default RequestResponseTab;
